var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "210-User",
    id: "_210-User"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.55,18A11,11,0,0,0,5,26v5H18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20,
    x2: 28,
    y1: 21,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28,
    x2: 20,
    y1: 21,
    y2: 29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanMembers);
export default __webpack_public_path__ + "static/media/ban-members.42cb3dd95b53e41b2814af0931d83c09.svg";
export { ForwardRef as ReactComponent };